// extracted by mini-css-extract-plugin
export default {"recos":"R1-z","productCardOverride":"S1-z","rowHasBadge":"T1-z"};